export default "__VITE_ASSET___v2Ydztf__"